import(/* webpackMode: "eager" */ "/builds/centralpoint.io/dev/dustintech/web/libraries/dustin-microsite/apps/productsite-beta/src/app/global-error.tsx");
